/**
 * @file
 * Manages the Historical Stats table.
 */

import * as React from 'react';

// Components
import ApiTable from '../../components/ApiTable/ApiTable';
import BassComponent from '../../components/BassComponent/BassComponent';

import meta from './meta';
import { apiParser, buildHistoricalStatsTableRow } from './processing';

// Types
import { AnglerId } from '../../types';
import { IAnglerHistoricalApiProcessed } from './types';

interface IProps {
  anglerId: AnglerId;
}

export class HistoricalStats extends React.Component<IProps, {}> {
  // Local property w/ type. Actual bound function assigned in constructor()
  public tableRowBuilder: (row: IAnglerHistoricalApiProcessed) => object;

  private apiBase = '/wp-json/data/v1/angler/stats?angler_id=';

  constructor(props: IProps) {
    super(props);

    const { anglerId } = props;
    this.tableRowBuilder = buildHistoricalStatsTableRow.bind({ anglerId });
  }

  public render() {
    return (
      <div data-testid="historical-stats-table">
        <BassComponent meta={{ ...meta }}>
          <div className="historical-stats-components">
            <ApiTable
              apiUri={this.apiUrl()}
              apiProcessor={apiParser}
              showHeader={false}
              smartStyles={false}
              tableRowFormatter={this.tableRowBuilder}
            />
          </div>
        </BassComponent>
      </div>
    );
  }

  private apiUrl = () => `${this.apiBase}${this.props.anglerId}`;
}

export default HistoricalStats;
